import React, { type ReactNode } from 'react';
import styled from '@emotion/styled';
import { ReactComponent as envZeroFullWhite } from 'assets/images/env-zero-full-white.svg';
import { Helmet } from 'react-helmet';

/**
 * The panel is flat: the design file specifies no illustrated background for any shell.
 */
export const OnboardingLayout: React.FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <>
      <Helmet>
        <title>env0 - Onboarding</title>
      </Helmet>
      <OuterContainer>
        <MainLayoutContainer>
          <EnvZeroFullLogo />
          <WhiteContainer>{children}</WhiteContainer>
        </MainLayoutContainer>
      </OuterContainer>
    </>
  );
};

const OuterContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
`;

const MainLayoutContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  overflow: auto;

  background: var(--surface-navigation-navigation);

  background-size: cover;
`;

const EnvZeroFullLogo = styled(envZeroFullWhite)`
  height: 40px;
  width: auto;
  margin: 50px;
  flex: none;
`;

const cardWidth = '970px' as const;
const WhiteContainer = styled.div`
  display: flex;
  overflow: auto;
  width: ${cardWidth};
  height: 80%;
  min-height: 750px;

  border-radius: var(--border-radius-200);
  background: var(--surface-main-cards);

  position: relative;
  z-index: 1;

  @media (max-width: ${cardWidth}) {
    width: 100%;
    height: min-content;
    border-radius: 0;
    flex: 1;
  }
`;

export default OnboardingLayout;
